"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countryHasFeature = countryHasFeature;
exports.countrySupportsUSState = countrySupportsUSState;
exports.getFlagSrc = getFlagSrc;
exports.getCurrencyFlagSrc = getCurrencyFlagSrc;
exports.getCountriesByEmploymentType = getCountriesByEmploymentType;
exports.filterCountriesByFeature = filterCountriesByFeature;
exports.findCountry = findCountry;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _constants = require("./constants");

var _constants2 = require("../employment/constants");

var _Country = require("../../services/Country");

/**
 * Check if provided country has specified feature
 *
 * @param {Object} country - The country object
 * @param {[String]} country.features
 * @param {String} feature - The feature key as provided by fetchAvailableCountryFeatures
 */
function countryHasFeature(country, feature) {
  var _ref = country || {},
      _ref$features = _ref.features,
      features = _ref$features === void 0 ? [] : _ref$features;

  return features.includes(feature);
}

function countrySupportsUSState(country) {
  var _ref2 = country || {},
      code = _ref2.code;

  return code === _constants.usCountryCode;
}

function getFlagSrc(country) {
  if (!country) return null;
  var countryName = typeof country === 'string' ? country : country.name;
  var name = countryName.toLowerCase();
  name = name.replace(/ /g, '-'); // Remove strings between (and including) brackets like: (UAE)

  if (name.indexOf('(') !== -1) {
    name = name.substring(0, name.indexOf('-('));
  }

  return "/images/flags/".concat(name, ".svg");
} // currency flags are usually the country flag


function getCurrencyFlagSrc(currencyCode) {
  var currencyCodeToFileName = {
    EUR: 'eur',
    USD: 'united-states',
    GBP: 'united-kingdom',
    AED: 'united-arab-emirates',
    ARS: 'argentina',
    AUD: 'australia',
    BGN: 'bulgaria',
    BYN: 'belarus',
    CAD: 'canada',
    CHF: 'switzerland',
    CLP: 'chile',
    CZK: 'czech-republic',
    DKK: 'denmark',
    EGP: 'egypt',
    GEL: 'georgia',
    GHS: 'ghana',
    HRK: 'croatia',
    HUF: 'hungary',
    IDR: 'indonesia',
    ILS: 'israel',
    INR: 'india',
    JPY: 'japan',
    KRW: 'south-korea',
    LKR: 'sri-lanka',
    MAD: 'morocco',
    MXN: 'mexico',
    MYR: 'malaysia',
    NGN: 'nigeria',
    NOK: 'norway',
    NZD: 'new-zealand',
    PKR: 'pakistan',
    PHP: 'philippines',
    PLN: 'poland',
    RON: 'romania',
    RUB: 'russia',
    SEK: 'sweden',
    SGD: 'singapore',
    THB: 'thailand',
    TRY: 'turkey',
    VND: 'vietnam',
    ZAR: 'south-africa'
  };
  var name = currencyCodeToFileName[currencyCode === null || currencyCode === void 0 ? void 0 : currencyCode.toUpperCase()];
  if (!name) return null;
  return "/images/flags/".concat(name, ".svg");
}

function getCountriesByEmploymentType(_x) {
  return _getCountriesByEmploymentType.apply(this, arguments);
}

function _getCountriesByEmploymentType() {
  _getCountriesByEmploymentType = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(type) {
    var fetchMethod, _yield$fetchMethod, data;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fetchMethod = _Country.fetchEmployerOnboardingCountries;

            if (type === _constants2.employmentType.CONTRACTOR) {
              fetchMethod = _Country.fetchCountries;
            }

            _context.next = 4;
            return fetchMethod();

          case 4:
            _yield$fetchMethod = _context.sent;
            data = _yield$fetchMethod.data.data;
            return _context.abrupt("return", data);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getCountriesByEmploymentType.apply(this, arguments);
}

function filterCountriesByFeature(feature) {
  return function (country) {
    return country.features.includes(feature);
  };
}
/**
 * Finds a country in a list of countries using slug, country code or country object.
 * @param {string | object} term country slug, country code or country object.
 * @param {object} countries list of country objects
 * @returns {object | null}
 */


function findCountry(term, countries) {
  if (!term) {
    return null;
  }

  var identifier = (0, _isString["default"])(term) ? term.toLowerCase() : term.slug;
  return countries.find(function (_ref3) {
    var slug = _ref3.slug,
        code = _ref3.code;

    if (slug === identifier) {
      return true;
    }

    if (code.toLowerCase() === identifier) {
      return true;
    }

    return false;
  });
}